module.exports = __webpack_public_path__ + "static/media/new_sharebot.d67f967a.svg";